import React from "react";
import { Check, HelpCircle } from "lucide-react";
import { about } from "../../mock";

export default function About() {
  return (
    <section id="about-us" className="py-20 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src={about.image}
                alt="Financial coaching consultation"
                className="w-full h-[460px] object-cover"
              />
            </div>
            <div className="absolute -top-5 -right-5 bg-navy text-white rounded-xl px-6 py-4 shadow-lg hidden sm:block">
              <div className="font-serif text-2xl font-bold text-gold">Since 2018</div>
              <div className="text-xs text-gray-300">Serving with integrity</div>
            </div>
          </div>

          <div>
            <span className="text-gold font-semibold tracking-[0.2em] uppercase text-sm">
              Who We Are
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl font-bold text-navy mt-3">
              {about.heading}
            </h2>
            <p className="mt-5 text-gray-600 text-lg leading-relaxed">
              {about.lead}
            </p>

            <div className="mt-8">
              <h3 className="font-serif text-xl font-semibold text-navy mb-4">
                Our team can help you address:
              </h3>
              <ul className="grid sm:grid-cols-2 gap-3">
                {about.addressList.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-gray-700">
                    <span className="mt-0.5 h-5 w-5 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0">
                      <Check className="h-3.5 w-3.5 text-gold-dark" />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-8 bg-white rounded-xl p-6 border border-gray-100 shadow-sm">
              <h3 className="font-serif text-xl font-semibold text-navy mb-4">
                We answer your questions:
              </h3>
              <ul className="space-y-2.5">
                {about.questions.map((q) => (
                  <li key={q} className="flex items-start gap-2.5 text-gray-700">
                    <HelpCircle className="h-5 w-5 text-navy-lighter flex-shrink-0 mt-0.5" />
                    {q}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
